module.exports = __webpack_public_path__ + "static/img/grid5 - Copy (2).69e6b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/grid5 - Copy (2).png
// module id = /MiR
// module chunks = 0